const SHARE_BUTTON_HOOK = '[js-hook-share-button]';

class share {
    constructor(element) {
        this.element = element;
        this.shareButtons = [...this.element.querySelectorAll(SHARE_BUTTON_HOOK)];

        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        this.shareButtons.forEach(button => {
            button.addEventListener('click', e => {
                this.openSharePopup(e);
            });
        });
    }

    openSharePopup(e) {
        e.preventDefault();

        const shareUrl = e.currentTarget.getAttribute('href');
        const windowTitle = e.currentTarget.getAttribute('title');
        const windowParams = 'width=500,height=400';

        window.open(shareUrl, windowTitle, windowParams).focus();
    }
}

export default share;
